import store from '@/store/store';

const hasDataLoadedGuard = async function hasDataLoadedGuard(to, from, next) {
    const campaignsLoading = store.getters['campaigns/getLoading']('advertiserCampaigns');
    if (campaignsLoading) return null;
    return next();
};

export default hasDataLoadedGuard;
